module.exports = "/img/mercedes.045edf39.png";